import { Component, Input, OnInit, forwardRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { LayoutService } from '../core/service/layout.service';

@Component({
    selector: 'app-utc-date-picker',
    templateUrl: './utcDatePicker.component.html',
    styleUrls: ['./utcDatePicker.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UtcDatePickerComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UtcDatePickerComponent implements OnInit, ControlValueAccessor {


  constructor(private cd: ChangeDetectorRef, public layout: LayoutService) { }

  dateValue: Date | string | undefined;
  @Input() readonly = false;
  @Input() name?: string;
  @Input() error = false;
  @Input() min?: Date | string;
  @Input() max?: Date | string;
  @Input() placeholder = 'Choose a date';
  private propagateChange: (value: string | null) => void = () => {};
  private propagateTouched: () => void = () => {};

  ngOnInit() {

  }

  dateChange(date: Date | null) {
    if (!date) {
      this.propagateChange(null);
      return;
    }

    const ticks = date.getTime();
    const offset = date.getTimezoneOffset();
    const adjusted = ticks - (offset * 60 * 1000);
    const adjustedDate = new Date(adjusted);
    const year = adjustedDate.getFullYear();
    let month = (adjustedDate.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = adjustedDate.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    const adjustedDateString = `${year}-${month}-${day}`;
    this.propagateChange(adjustedDateString);
  }

  writeValue(value: string | null | undefined) {

    if (value) {
      this.dateValue = value.split('T')[0];
      this.cd.detectChanges();
    } else {
      this.dateValue = undefined;
    }
  }
  registerOnChange(fn: (value: string | null) => void) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void) {
    this.propagateTouched = fn;
  }

  markTouched() {
    this.propagateTouched();
  }


}
